module.exports = __webpack_public_path__ + "img/FI.3ea1eda4.svg";